const getFileExtension = (filename: string): string => {
  const matches = filename.match(/^.*?(?:\.([^.]+))?$/);

  return matches && matches.length === 2 ? matches[1] : "";
};

export default getFileExtension;
